import {  pbxGlobalSelect,PBX_GS } from '../helper/constants';
import { mapState, mapMutations, mapGetters } from 'vuex';
import _, { set as _set,} from 'lodash';
import {
  computedPbxPlans,
  computedPbxCallingPlans,
  computedPbxTollFreePlans,
  computedPbxPhoneNumberPlans,
} from '@/common/service/computers/plans/pbx';



export default {
  computed: {
    ...mapGetters(['getSelectedPlans', 'getSubscriptions', 'plancodeMapSubscriptionDisabled', 'getSelectedPlansMap', 'basicConfig', 'boughtPlans']),
    ...mapState({ planMapFlat: (state) => state.ShoppingCart.planMapFlat }),
    isGlobalSelect(){
      return computedPbxPlans(this.getSelectedPlans).some(item => PBX_GS.includes(item.category)) && this.$config('enableZoomPhoneGlobalSelect')
    },
    selectedPlansLabelList() {
      return [...this.selectedCallingPlans, ...this.selectedAdditionalPlans].map(plan => {
        const regionLabel =  this.$t('billing.pbx.global_select')
        const planName = this.$t(plan.planNameKey)
        const numbersLabel = `${plan.cartInfo.selected_number} ${this.$t('billing.planform.unit.number').toLowerCase()}`
        const price = `${this.$money(plan.amount)}${this.getTranslateUnit(plan.billing_cycle)}`
        return `${regionLabel} • ${planName} • ${numbersLabel} • ${price}`
      });
    },
    globalSelectPlans(){
      return computedPbxPlans(this.planMapFlat).filter(item => PBX_GS.includes(item.category))
    },
    globalSelectCallingPlans(){
      return  computedPbxCallingPlans(this.globalSelectPlans);
    },
    globalSelectAdditionalPlans(){
      return [...computedPbxPhoneNumberPlans(this.globalSelectPlans), ...computedPbxTollFreePlans(this.globalSelectPlans)];
    },
  },
  methods: {
    ...mapMutations(['updateSelectPlans', 'removePlan']),
    fillSelectModel(thisRegionsConfig = {}) {
      // ignoring thisRegionsConfig will return a plain object to init data.regionsConfig
      const _map = (plans) =>
        plans.map((x) => ({
          id: x.plan_code,
          number: x.cartInfo?.selected_number ?? 0,
        }));
      pbxGlobalSelect.forEach((region) => {
        const plans = _.chain(this.boughtPbxPlans || [])
          .map((p) => (this.getSelectedPlansMap[p.plan_code] || p)) // selected plans overwrite bought plans
          .concat(this.getSelectedPlans || [])
          .filter((x) => (PBX_GS.includes(x.category)))
          .uniqBy((p) => p.plan_code)
          .value();
          
        const callingPlans = computedPbxCallingPlans(plans);
        const additionalPlans = [...computedPbxPhoneNumberPlans(plans), ...computedPbxTollFreePlans(plans)];
        _set(thisRegionsConfig, `${region.key}.callings`, _map(callingPlans));
        _set(thisRegionsConfig, `${region.key}.additions`, _map(additionalPlans));
      });
      return thisRegionsConfig;
    },
    testRegionalCallingPlansFull(billingCycle) {
      const plans = this.globalSelectCallingPlans.filter(x => x.billing_cycle === billingCycle);
      return this.regionsConfig[this.activeRegionKey]?.callings?.length === plans.length;
    },
    testRegionalAdditionalPlansFull(billingCycle) {
      const plans = this.globalSelectAdditionalPlans.filter(x => x.billing_cycle === billingCycle);
      return this.regionsConfig[this.activeRegionKey]?.additions?.length === plans.length;
    },
    getRegionLabelById() {
      return this.$t('billing.pbx.global_select')
    },
    async showPlanDetailDialog() {
      this.$tracking.buyInteraction('plan details selected', 'zoom phone global select');
      await this.fullComparisonDialog.confirm({ showAction: false });
    },
  },
};
